import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiEye, FiEyeOff } = FiIcons;

const Input = ({ label, error, className = '', type = 'text', ...props }) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === 'password';
  const inputType = isPasswordField && showPassword ? 'text' : type;

  return (
    <div className="space-y-1.5">
      {label && (
        <label className="text-sm font-medium text-zinc-400 ml-1">
          {label}
        </label>
      )}
      <div className="relative">
        <input
          className={`w-full bg-zinc-900/50 border ${
            error
              ? 'border-red-500 focus:ring-red-500/20'
              : 'border-zinc-800 focus:border-red-500 focus:ring-red-500/20'
          } rounded-xl px-4 py-3 ${
            isPasswordField ? 'pr-12' : ''
          } text-white placeholder-zinc-500 focus:outline-none focus:ring-4 transition-all duration-200 ${className}`}
          type={inputType}
          {...props}
        />
        {isPasswordField && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-zinc-300 transition-colors p-1"
            tabIndex={-1}
          >
            <SafeIcon
              icon={showPassword ? FiEyeOff : FiEye}
              className="text-xl"
            />
          </button>
        )}
      </div>
      {error && (
        <p className="text-xs text-red-500 font-medium ml-1">{error}</p>
      )}
    </div>
  );
};

export default Input;